<script lang="ts">
export default {
  name: "public-layout",
  inheritAttrs: false,
  customOptions: {},
};
</script>

<script setup lang="ts">
import { reactive } from "vue";

const data = reactive({
  test: "Public Layout",
});
</script>
<template>
  <div>{{ data.test }}</div>
</template>
